import React, { Component } from "react";
import DataGrid, {
  Column,
  Export,
  Grouping,
  GroupPanel,
  HeaderFilter,
  Pager,
  Paging,
  SearchPanel,
  SortByGroupSummaryInfo,
} from "devextreme-react/data-grid";
import { getRequestParams } from "../../helpers/globalfunctions.js";
export class ServiceProviderComponent extends Component {
  static displayName = ServiceProviderComponent.name;
  constructor(props) {
    super(props);
    this.state = {
      serviceProviderGridDataSource: null,
    };
    this.refDataGrid = React.createRef(null);
    this.isComponentDidMounted = false;
  }
  componentDidMount() {
    try {
      if (this.isComponentDidMounted) {
        return;
      }
      document.querySelector("#lblPageTitle").innerHTML = `Local Vender`;
      setTimeout(async () => {
        await this.getServiceProvider();
      }, 0);
      this.isComponentDidMounted = true;
    } catch (error) {
      console.log(error);
    }
  }
  getServiceProvider = async () => {
    try {
      let apiUrl = `${process.env.REACT_APP_API_BASE_URL}Account/ServiceProviders`;
      const response = await fetch(apiUrl, getRequestParams("GET", null));
      const data = await response.json();
      this.setState({
        serviceProviderGridDataSource: data.payload ?? [],
      });
    } catch (err) {
      console.log(
        "Error in " + this.displayName + ".getServiceProvider function",
        err
      );
    }
  };
  getAccountTracking = (e, currentPageName, data) => {
    e.preventDefault();
    sessionStorage.setItem("session_PageName", currentPageName);
    this.props.history.push({
      pathname: "/tracking",
      state: {
        transporterId: data.transportId,
        sourceUrl: "/service-providers",
      },
    });
  };
  render() {
    const renderTrackAccount = (data) => {
      return (
        <span>
          <a
            href="#"
            onClick={(e) => {
              this.getAccountTracking(e, "Tracking", data.data);
            }}
            style={{ textDecoration: "underline", cursor: "pointer" }}
            title={data.data.transportName}
          >
            {data.data.transportName}
          </a>
        </span>
      );
    };

    return (
      <div className="card">
        <div className="card-body">
          <DataGrid
            ref={this.refDataGrid}
            dataSource={this.state.serviceProviderGridDataSource}
            columnsAutoWidth={true}
            showColumnLines={true}
            showRowLines={true}
            showBorders={true}
            rowAlternationEnabled={false}
            allowColumnResizing={true}
            onToolbarPreparing={(e) => {
              e.toolbarOptions.items.unshift({
                location: "after",
                widget: "dxButton",
                options: {
                  icon: "refresh",
                  onClick: async (e) => {
                    e.component.option("icon", "fas fa-spinner fa-spin");
                    await this.getServiceProvider();
                    e.component.option("icon", "refresh");
                  },
                },
              });
            }}
          >
            <Column
              dataField="transportId"
              caption="Transport #"
              allowFiltering={false}
              allowSearch={true}
              width={"auto"}
              dataType={"string"}
            />
            <Column
              dataField="transportName"
              caption="Transporter"
              allowFiltering={false}
              allowSearch={true}
              cellRender={renderTrackAccount}
            />
            <Column
              dataField="contactNumber"
              caption="Contact No"
              allowFiltering={false}
              allowSearch={true}
            />
            <Column
              dataField="email"
              caption="Email"
              allowFiltering={false}
              allowSearch={true}
            />
            <Column
              dataField="address"
              caption="Address"
              allowFiltering={false}
              allowSearch={true}
            />

            <SortByGroupSummaryInfo summaryItem="count" />
            <GroupPanel visible={false} />
            <HeaderFilter visible={true} />
            <SearchPanel
              visible={true}
              highlightCaseSensitive={true}
              width={240}
              placeholder="Search..."
            />
            <Grouping autoExpandAll={true} />
            <Paging defaultPageSize={20} />
            <Pager
              showPageSizeSelector={true}
              allowedPageSizes={[10, 20, 50]}
              showInfo={true}
              visible={true}
            />
            <Export
              enabled={true}
              allowExportSelectedData={false}
              fileName="ServiceProvider"
            />
          </DataGrid>
        </div>
      </div>
    );
  }
}
